import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/adobe/pageView.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/adobe/vehicleAnalytics.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/chart/chart.component.tsx");
;
import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/cta-dispatch.component.tsx");
;
import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/cta-financing/cta-financing.scss");
;
import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/breadcrumb/breadcrumb.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/news/news.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResultContextProvider"] */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/pages/result/result.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/related-offers/related-offers.component.tsx");
;
import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/results/results-section.scss");
;
import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/related/related.scss");
;
import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/pages/result/result.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/similar-models/similar-models.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TablesVehiclePriceComponent"] */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/tables-vehicle-price/tables-vehicle-price.component.tsx");
;
import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/technical-sheet/technical-sheet.scss");
;
import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/components/versions/versions.scss");
